import { IconProps } from "../../../types/style";

const LocationFill = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M10.31 4.725C9.78505 2.415 7.77005 1.375 6.00005 1.375C6.00005 1.375 6.00005 1.375 5.99505 1.375C4.23005 1.375 2.21005 2.41 1.68505 4.72C1.10005 7.3 2.68005 9.485 4.11005 10.86C4.64005 11.37 5.32005 11.625 6.00005 11.625C6.68005 11.625 7.36005 11.37 7.88505 10.86C9.31505 9.485 10.895 7.305 10.31 4.725Z"
          fill={color}
        />
        <path
          d="M6.00005 7.23008C6.8699 7.23008 7.57505 6.52493 7.57505 5.65508C7.57505 4.78523 6.8699 4.08008 6.00005 4.08008C5.1302 4.08008 4.42505 4.78523 4.42505 5.65508C4.42505 6.52493 5.1302 7.23008 6.00005 7.23008Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default LocationFill;
